<template>
  <el-dialog
    :append-to-body="true"
    :visible.sync="dialog"
    title=""
    width="480px"
    v-dialog-drag
    :close-on-click-modal="false"
    :show-close="false"
  >
    <register @done="done"></register>
  </el-dialog>
</template>

<script>
import myRules from '@/utils/rules'
import AreaCascader from '@/components/Area/AreaCascader.vue'
import request from '@/utils/request'
import SmsCodeInput from '@/components/Sms/SmsCodeInput.vue'
import Register from "@/views/register.vue";

export default {
  name: 'OrgApply',
  components: {Register, SmsCodeInput, AreaCascader },
  props: {},
  data() {
    return {
      title: '机构',
      dialog: false,
    }
  },
  watch: {
    action: function(val) {
      this.disabled = val === 'view'
    },
    dialog: function(val) {
      if (!val) {
        this.clearForm()
      }
    }
  },
  methods: {
    /**
     * 完成
     */
    done(refresh) {
      this.dialog = false
      this.$emit('done', refresh)
    }
  }
}
</script>

<style lang="scss">
.el-dialog__header {
  padding: 0px !important;
}
.el-dialog__body{
  padding: 0px!important;
}
</style>
